export default "__VITE_ASSET__BeYB9J7b__"